import React from 'react';

export interface ReelPlaybackControlsProps {
  soundEnabled: boolean;
  userPaused: boolean;
  onSoundToggle: () => void;
  onPlayPauseToggle: () => void;
  className?: string;
}

/**
 * Play/pause and mute toggles for reel video (Gönderiler feed and listing reel overlay).
 */
const ReelPlaybackControls: React.FC<ReelPlaybackControlsProps> = ({
  soundEnabled,
  userPaused,
  onSoundToggle,
  onPlayPauseToggle,
  className = '',
}) => (
  <div className={`reel-playback-controls d-flex flex-column gap-2 ${className}`.trim()}>
    <button
      type="button"
      className="btn btn-light btn-sm rounded-circle"
      style={{ width: 40, height: 40 }}
      onClick={onSoundToggle}
      aria-label={soundEnabled ? 'Sesi kapat' : 'Sesi aç'}
      title={soundEnabled ? 'Sesi kapat' : 'Sesi aç'}
    >
      <i className={`fas ${soundEnabled ? 'fa-volume-up' : 'fa-volume-mute'}`} />
    </button>
    <button
      type="button"
      className="btn btn-light btn-sm rounded-circle"
      style={{ width: 40, height: 40 }}
      onClick={onPlayPauseToggle}
      aria-label={userPaused ? 'Oynat' : 'Duraklat'}
      title={userPaused ? 'Oynat' : 'Duraklat'}
    >
      <i className={`fas ${userPaused ? 'fa-play' : 'fa-pause'}`} />
    </button>
  </div>
);

export default ReelPlaybackControls;
